import { Box, Button, Stack } from '@mui/material';
import { useLang, type Lang } from './lang.js';

/**
 * EN / TR switch for the pages that carry no language in their URL.
 *
 * The marketing pages use `/` and `/tr` because they are shared and indexed.
 * Someone arriving at the sign-in screen from an email link has nothing in the
 * URL to go on, so the choice is remembered instead.
 */
export function LangToggle({ sx }: { sx?: object }) {
  const [lang, setLang] = useLang();

  const item = (value: Lang, label: string) => (
    <Button
      size="small"
      onClick={() => setLang(value)}
      aria-current={lang === value ? 'true' : undefined}
      sx={{
        minWidth: 40,
        px: 1,
        fontWeight: 700,
        color: lang === value ? 'text.primary' : 'text.disabled',
        '&:hover': { color: 'text.primary', bgcolor: 'transparent' },
      }}
    >
      {label}
    </Button>
  );

  return (
    <Stack direction="row" alignItems="center" aria-label="Language" sx={sx}>
      {item('en', 'EN')}
      <Box sx={{ width: '1px', height: 16, bgcolor: 'divider' }} />
      {item('tr', 'TR')}
    </Stack>
  );
}
